<section class="lg:py-16 bg-[#0B0F17] border-t border-white/10 relative z-10">
  <app-content-container>
    <div class="flex flex-col items-center">
      <div class="flex flex-col max-w-[700px] w-full">
        <div class="flex justify-center">
          <img
            class="w-[200px] lg:w-[300px]"
            src="/images/logomark/logo-cd-full.svg"
            alt="Code Dimension"
          />
        </div>

        <div class="flex flex-col lg:flex-row mt-20 lg:mt-20">
          <div
            class="flex justify-center lg:justify-start lg:mt-0 lg:basis-1/3"
          >
            <div class="flex flex-col items-center lg:items-start">
              <h3 class="text-lg font-bold">Sobre</h3>

              @for (item of aboutLinks(); track item.label) {
              <a
                class="flex mt-6 hover:decoration-[#6657ec] hover:decoration-solid hover:underline hover:underline-offset-2"
                [href]="item.link"
              >
                {{ item.label }}
              </a>
              }
            </div>
          </div>

          <div class="flex justify-center mt-12 lg:mt-0 lg:basis-1/3">
            <div class="flex flex-col items-center lg:items-baseline">
              <h3 class="text-lg font-bold">Podimension</h3>

              @for (item of podimensionLinks(); track item.label) {
              <a
                class="flex mt-6 hover:decoration-[#6657ec] hover:decoration-solid hover:underline hover:underline-offset-2"
                [href]="item.link"
              >
                {{ item.label }}
              </a>
              }
            </div>
          </div>

          <div
            class="flex justify-center mt-12 lg:mt-0 lg:justify-end lg:basis-1/3"
          >
            <div class="flex flex-col items-center lg:items-start">
              <h3 class="text-lg font-bold">Rede Sociais</h3>

              @for (item of socialMediaLinks(); track item.label) {
              <a class="flex mt-6" [href]="item.link">
                <img class="w-[25px]" [src]="item.icon" [alt]="item.label" />
                <span
                  class="hover:decoration-[#6657ec] hover:decoration-solid hover:underline hover:underline-offset-2 ml-1"
                >
                  {{ item.label }}
                </span>
              </a>
              }
            </div>
          </div>
        </div>
      </div>

      <div
        class="flex flex-col lg:flex-row justify-center items-center mt-20 gap-6"
      >
        <div
          class="flex items-center gap-2 text-sm text-gray-400 bg-white/5 px-4 py-2 rounded-full border border-white/10"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 text-success"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
            />
          </svg>
          <span>Ambiente 100% Seguro</span>
        </div>
        <div
          class="flex items-center gap-2 text-sm text-gray-400 bg-white/5 px-4 py-2 rounded-full border border-white/10"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 text-success"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            />
          </svg>
          <span>Pagamento via Hotmart</span>
        </div>
      </div>
      <div
        id="copyright"
        class="flex justify-center mt-6 font-bold text-gray-500"
      ></div>
    </div>
  </app-content-container>
</section>
